var _g, _path, _g2, _path2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.937 52.1101L77.613 52.7521C75.111 52.9351 74.079 55.9921 75.987 57.5791L83.151 63.4441C84.714 64.7251 87.093 64.0531 87.72 62.1601L89.847 55.7761C90.504 53.8831 88.971 51.9571 86.937 52.1101Z",
    fill: "#F6C327"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.937 52.1101L77.613 52.7521C75.111 52.9351 74.079 55.9921 75.987 57.5791L83.151 63.4441C84.714 64.7251 87.093 64.0531 87.72 62.1601L89.847 55.7761C90.504 53.8831 88.971 51.9571 86.937 52.1101Z",
    fill: "url(#paint0_radial_475_12218)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.25 9.17966L63.09 17.8797C62.49 20.2197 65.07 22.1097 67.11 20.8197L74.73 16.0797C76.38 15.0597 76.47 12.6597 74.88 11.5197L69.54 7.64966C69.1787 7.38024 68.7565 7.20423 68.3108 7.13729C67.8651 7.07034 67.4098 7.11453 66.9853 7.26592C66.5608 7.41731 66.1803 7.67122 65.8776 8.00508C65.5749 8.33895 65.3593 8.74242 65.25 9.17966Z",
    fill: "#F4C226"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.25 9.17966L63.09 17.8797C62.49 20.2197 65.07 22.1097 67.11 20.8197L74.73 16.0797C76.38 15.0597 76.47 12.6597 74.88 11.5197L69.54 7.64966C69.1787 7.38024 68.7565 7.20423 68.3108 7.13729C67.8651 7.07034 67.4098 7.11453 66.9853 7.26592C66.5608 7.41731 66.1803 7.67122 65.8776 8.00508C65.5749 8.33895 65.3593 8.74242 65.25 9.17966Z",
    fill: "url(#paint1_linear_475_12218)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.29 16.0856L26.88 20.8256C28.92 22.1156 31.5 20.2556 30.93 17.8856L28.77 9.18561C28.6593 8.7493 28.4436 8.34667 28.1417 8.01281C27.8398 7.67895 27.4609 7.424 27.0378 7.27018C26.6148 7.11635 26.1606 7.06832 25.7148 7.13027C25.2689 7.19222 24.845 7.36227 24.48 7.62561L19.14 11.4956C17.55 12.6956 17.64 15.0656 19.29 16.0856Z",
    fill: "#EABA25"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5551 63.2398L19.4251 57.4798C21.2851 55.9198 20.2951 52.8898 17.8951 52.7398L8.95506 52.1098C8.50481 52.0782 8.05369 52.1575 7.64123 52.3408C7.22876 52.5241 6.86754 52.8057 6.5892 53.161C6.31087 53.5164 6.12393 53.9345 6.04475 54.3789C5.96557 54.8232 5.99658 55.2802 6.13506 55.7098L8.17506 61.9798C8.77506 63.8398 11.0851 64.4998 12.5551 63.2398Z",
    fill: "#DFAD26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5551 63.2398L19.4251 57.4798C21.2851 55.9198 20.2951 52.8898 17.8951 52.7398L8.95506 52.1098C8.50481 52.0782 8.05369 52.1575 7.64123 52.3408C7.22876 52.5241 6.86754 52.8057 6.5892 53.161C6.31087 53.5164 6.12393 53.9345 6.04475 54.3789C5.96557 54.8232 5.99658 55.2802 6.13506 55.7098L8.17506 61.9798C8.77506 63.8398 11.0851 64.4998 12.5551 63.2398Z",
    fill: "url(#paint2_linear_475_12218)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.385 85.1157L50.025 76.8057C49.125 74.5557 45.945 74.5557 45.045 76.8057L41.685 85.1157C40.965 86.9157 42.285 88.8957 44.235 88.8957H50.835C51.2843 88.8933 51.7263 88.7812 52.1225 88.5693C52.5187 88.3573 52.8571 88.0517 53.1084 87.6792C53.3597 87.3067 53.5163 86.8785 53.5645 86.4317C53.6127 85.985 53.5511 85.5332 53.385 85.1157Z",
    fill: "#E3B028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.385 85.1157L50.025 76.8057C49.125 74.5557 45.945 74.5557 45.045 76.8057L41.685 85.1157C40.965 86.9157 42.285 88.8957 44.235 88.8957H50.835C51.2843 88.8933 51.7263 88.7812 52.1225 88.5693C52.5187 88.3573 52.8571 88.0517 53.1084 87.6792C53.3597 87.3067 53.5163 86.8785 53.5645 86.4317C53.6127 85.985 53.5511 85.5332 53.385 85.1157Z",
    fill: "url(#paint3_linear_475_12218)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_iii_475_12218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6952 11.0758L57.8732 22.2358C58.8512 24.3178 60.7742 25.7758 63.0242 26.1028L75.1922 27.9778C80.6972 28.8118 82.9172 35.5678 79.0712 39.5518L69.8042 49.1068C69.0583 49.876 68.5035 50.8097 68.1846 51.8326C67.8657 52.8555 67.7916 53.939 67.9682 54.9958L70.0982 68.1208C71.0192 73.7728 65.0372 77.9998 60.0362 75.2308L49.8212 69.5488C48.8094 68.9784 47.6676 68.6787 46.5062 68.6787C45.3447 68.6787 44.2029 68.9784 43.1912 69.5488L32.9792 75.2338C27.9752 77.9998 21.9962 73.7728 22.9142 68.1208L25.0442 54.9958C25.2208 53.939 25.1466 52.8555 24.8277 51.8326C24.5088 50.8097 23.954 49.876 23.2082 49.1068L13.9442 39.5548C10.0652 35.5348 12.3152 28.8118 17.8232 27.9748L29.9882 26.1028C31.0968 25.9255 32.1454 25.4803 33.0431 24.8059C33.9407 24.1315 34.6602 23.2483 35.1392 22.2328L40.3202 11.0728C42.7772 5.77781 50.2382 5.77781 52.6922 11.0728",
    fill: "url(#paint4_radial_475_12218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6952 11.0758L57.8732 22.2358C58.8512 24.3178 60.7742 25.7758 63.0242 26.1028L75.1922 27.9778C80.6972 28.8118 82.9172 35.5678 79.0712 39.5518L69.8042 49.1068C69.0583 49.876 68.5035 50.8097 68.1846 51.8326C67.8657 52.8555 67.7916 53.939 67.9682 54.9958L70.0982 68.1208C71.0192 73.7728 65.0372 77.9998 60.0362 75.2308L49.8212 69.5488C48.8094 68.9784 47.6676 68.6787 46.5062 68.6787C45.3447 68.6787 44.2029 68.9784 43.1912 69.5488L32.9792 75.2338C27.9752 77.9998 21.9962 73.7728 22.9142 68.1208L25.0442 54.9958C25.2208 53.939 25.1466 52.8555 24.8277 51.8326C24.5088 50.8097 23.954 49.876 23.2082 49.1068L13.9442 39.5548C10.0652 35.5348 12.3152 28.8118 17.8232 27.9748L29.9882 26.1028C31.0968 25.9255 32.1454 25.4803 33.0431 24.8059C33.9407 24.1315 34.6602 23.2483 35.1392 22.2328L40.3202 11.0728C42.7772 5.77781 50.2382 5.77781 52.6922 11.0728",
    fill: "url(#paint5_radial_475_12218)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_475_12218",
    x: 74.9507,
    y: 51.9016,
    width: 15.1752,
    height: 12.251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.125,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.607843 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.945098 0 0 0 0 0.372549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_475_12218",
    result: "effect2_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_475_12218",
    x: 62.8017,
    y: 7.10693,
    width: 13.47,
    height: 14.3318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.94902 0 0 0 0 0.294118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.705882 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_475_12218",
    result: "effect2_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_475_12218",
    x: 17.8483,
    y: 6.904,
    width: 13.362,
    height: 14.494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905882 0 0 0 0 0.298039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.658824 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_475_12218",
    result: "effect2_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_475_12218",
    x: 5.87695,
    y: 51.978,
    width: 14.5161,
    height: 11.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.125,
    dy: -0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.615686 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_475_12218",
    x: 41.4858,
    y: 74.9682,
    width: 12.3445,
    height: 13.9273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.588235 0 0 0 0 0.282353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_iii_475_12218",
    x: 11.375,
    y: 6.85156,
    width: 70.375,
    height: 69.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.494118 0 0 0 0 0.282353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.625,
    dy: 0.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.952941 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_475_12218",
    result: "effect2_innerShadow_475_12218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.619608 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_475_12218",
    result: "effect3_innerShadow_475_12218"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_475_12218",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.218 58.5721) rotate(-27.3239) scale(12.6628 17.5645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#FFF055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_475_12218",
    x1: 74.157,
    y1: 8.50766,
    x2: 72.093,
    y2: 11.6037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF659",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_475_12218",
    x1: 13.1971,
    y1: 52.1038,
    x2: 13.1971,
    y2: 55.1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAE2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_475_12218",
    x1: 52.875,
    y1: 82.0077,
    x2: 49.593,
    y2: 83.4147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C83C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_475_12218",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5113 24.3428) rotate(132.911) scale(49.3992 48.8835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C632"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_475_12218",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5002 41.6038) rotate(90) scale(34.5 34.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDBA38",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3b12fe17a801a5c516b8062f3bcbdaee.svg";
export { ForwardRef as ReactComponent };